import type { ReactNode, RefObject } from 'react'
import { cn } from '@/utils'

type TrayGridProps = {
  /** From `useTrayLazyWindow` — 1 for short result lists, 2 otherwise. */
  columns: 1 | 2
  children?: ReactNode
  /** From `useTrayLazyWindow`; the sentinel renders only while `showSentinel` is true. */
  sentinelRef?: RefObject<HTMLDivElement | null>
  showSentinel?: boolean
}

/** Thumbnail grid for a right-panel tray, followed by the lazy-load sentinel. */
export function TrayGrid({ columns, children, sentinelRef, showSentinel = false }: TrayGridProps) {
  return (
    <>
      <div
        className={cn(
          'grid w-full min-w-0 gap-2 p-0.5 py-2',
          columns === 1 ? 'grid-cols-1' : 'grid-cols-2'
        )}
      >
        {children}
      </div>
      {showSentinel ? <div ref={sentinelRef} className="h-4 w-full" aria-hidden="true" /> : null}
    </>
  )
}
